import TaskModalProducts from './TaskModalProducts';
import { TaskCard, Modal } from '@ui';
import './index.scss';

const TaskModal = ({ task, onClose, activate }) => (
  <Modal
    framed
    onClose={onClose}
    crossOutside
    size='fromLg:w-[844px] fromLg:max-w-[844px] fromMd:w-[756px] fromMd:max-w-[756px] sm:max-h-[570px]'
    className='task-modal__modal sm:overflow-auto'
    closeClassName='sm:bg-white sm:p-1 sm:rounded-full'
    placementMobile='bottom-sheet'
  >
    <div className='task-modal'>
      <TaskCard activate={activate} task={task} />
      <div className='task-modal__info'>
        <div className='task-modal__heading'>{task.name}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: task.text
          }}
          className='task-modal__text'
        />
        {!!task.products?.length && (
          <div className='task-modal__products-wrapper custom-scroll'>
            <div className='task-modal__products'>
              <TaskModalProducts list={task.products} status={task.type} />
            </div>
          </div>
        )}
      </div>
    </div>
  </Modal>
);

export default TaskModal;
